import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import TableJobDescription from "./TableJobDescription";
import { useEffect, useState } from "react";

export default function JobDescription({ setData, initialState }) {
  const jobDescriptionData = initialState?.project_job_enquiry_description;
  const [show, setShow] = useState(false);
  const [jobDescriptions, setJobDescriptions] = useState(
    jobDescriptionData || []
  );

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      job_description_edit: jobDescriptions
        ?.filter((data) => data?.type != "new")
        ?.map((data) => ({
          job_description_id: data?.id,
          description: data?.description,
        })),
      job_description_new: jobDescriptions
        ?.filter((data) => data?.type == "new")
        ?.map((data) => ({
          description: data?.description,
        })),
    }));
  }, [jobDescriptions]);

  return (
    <div className="flex flex-wrap gap-4 ">
      <div className=" w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          onClick={() => setShow((p) => !p)}
          type="button"
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Job Description</h2>
          <p>Provide Job Descriptions.</p>
        </div>
      </div>
      <div
        className={`w-full m-2 overflow-hidden px-4 rounded-md transition-all  ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
        }`}
      >
        <button
          type="button"
          className="bg-red text-white p-2 rounded-md mt-2 ml-2"
          onClick={() => {
            setJobDescriptions((prev) => [
              ...prev,
              {
                id: Math.floor(Math.random() * 10000),
                description: "",
                type: "new",
              },
            ]);
          }}
        >
          + Add Another
        </button>
        <TableJobDescription
          setData={setData}
          jobDescriptions={jobDescriptions}
          setJobDescriptions={setJobDescriptions}
        />
      </div>
    </div>
  );
}
